const corePlugin = require('yuzu-plugin-core');
const formsPlugin = require('yuzu-plugin-forms');
const gridPlugin = require('yuzu-plugin-grid');

module.exports = {
    initScripts: () => {
        let base = require.context('./_dev/_source/js/controllers', true, /\.js$/);
        let forms = formsPlugin.initScripts();

        return [base, forms];
    },
    initForYuzuLoader: (config) => {
        corePlugin.initForYuzuLoader(config);
        formsPlugin.initForYuzuLoader(config);
        gridPlugin.initForYuzuLoader(config);

        config.renderedPartialDirs.push('./node_modules/@yuzu/yuzu-plugin-base/_dev/_templates/pages');
        config.renderedPartialDirs.push('./node_modules/@yuzu/yuzu-plugin-base/_dev/_templates/blocks');
        config.renderedPartialDirs.push('./node_modules/@yuzu/yuzu-plugin-base/_dev/_templates/_dataStructures');
        config.registeredPartialsDirs.push('./node_modules/@yuzu/yuzu-plugin-base/_dev/_templates/blocks');
        config.dependantDirectories.push('./node_modules/@yuzu/yuzu-plugin-base/_dev/_templates/blocks');
    },
    initForYuzuApi: (config) => {
        corePlugin.initForYuzuApi(config);
        formsPlugin.initForYuzuApi(config);
        gridPlugin.initForYuzuApi(config);

        config.api.files.templates.push('./node_modules/@yuzu/yuzu-plugin-base/_dev/_templates');
    },
    spriteSource: () => {
        return './node_modules/@yuzu/yuzu-plugin-base/_dev/_source/svg-spritesheet/**/*.svg';
    },
    tailwindContent: () => {
        return ['./node_modules/@yuzu/yuzu-plugin-base/_dev/**/*.hbs', './node_modules/@yuzu/yuzu-plugin-base/_dev/**/*.html', './node_modules/@yuzu/yuzu-plugin-base/_dev/**/*.js'];
    },
    tailwindConfig: () => {
        return require('./tailwind.config');
    }
};